import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";
import { t } from '@lang/i18n';

const PreviewPdf = ({ file, showPDF, setShowPDF }) => {

    const isAndroid = () => {
        return navigator.userAgent.toLowerCase().indexOf("android") > -1
    };  

    const getFileExtension = (filename) => {
        return filename && filename.split('.').pop().toLowerCase();
    };
    const docContent = `<div> <img src=${file} width='100%' height='100%'/></div>`

    const previewCV = (file, docContent) => {
        if (getFileExtension(file) === "pdf" || isAndroid()) {
            return <iframe src={`https://docs.google.com/gview?embedded=true&url=${file}&amp;embedded=true`} width="100%" height="100%">
                    </iframe>
        } else if (getFileExtension(file) === "jpeg" || getFileExtension(file) === "jpg" || getFileExtension(file) === "png" || getFileExtension(file) === "bmp") {
            return  <iframe srcdoc={docContent} src={file} width="100%" height="100%">
                    </iframe>
        } else {
            return <iframe src={file} width="100%" height="100%">
                    </iframe>
        }
    };

    return(
        <Modal isOpen={showPDF} onClose={setShowPDF} size={"6xl"} bg="white" borderRadius="16px">
            <ModalOverlay />
            <ModalContent maxHeight="100%" h={["80vh", "100vh"]}>
                <ModalHeader> { t('global.cv_candidat') } </ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    { previewCV(file, docContent) }
                    {/* <Flex justifyContent="center" mt="3rem">
                        <Spinner size="xl" thickness="4px" color="green.main" />
                    </Flex> */}
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}

export default PreviewPdf;